<template>
  <div>
    <Header/>
    <Scroll/>

    <div class="mall_mypageWrap">
      <div class="pageProductDatail_Inner">
        <div class="pageProductDatail_flexBox"></div> <!-- 플렉스용 -->
        <div class="pageProductDatail_imgBox">
          <div class="pageProductDatail_thumbnail">
            <img
              :src="currentImage"
              :alt="statusData.productData.product_kor_name"
              @mouseover="hoverImage(true)"
              @mouseout="hoverImage(false)"
            />
          </div>
          <div class="pageProductDatail_imgDetail pageProductDatail_imgDetailPc"> <!-- 상세이미지 Pc용 -->
            <!-- 동영상1 부분 임시로 주석처리함
            <video
              :src="statusData.productData.product_video+'#t=0.1'"
              controls
              playsinline
              v-if="statusData.productData.product_video"
              /> -->
            <img
              :src="statusData.productData.product_image_detail"
              :alt="statusData.productData.product_eng_name"
            />
            <video
              :src="statusData.productData.product_video_2+'#t=0.1'"
              controls
              playsinline
              v-if="statusData.productData.product_video_2"
              />
            <img
              :src="statusData.productData.product_image_detail_2"
              :alt="statusData.productData.product_eng_name"
            />
          </div>
        </div>

        <div class="pageProductDatail_explainBox"> <!-- 제품 설명박스 -->
          <div class="mall_pListBox_stateTag">
            <div class="mall_pListBox_stateTag_new" v-if="statusData.productData.product_new === 1">New</div>
            <div class="mall_pListBox_stateTag_inStock" v-if="statusData.productData.product_in_stock === 1">재고보유</div>
            <div class="mall_pListBox_stateTag_best" v-if="statusData.productData.product_best === 1">Best</div>
            <div class="mall_pListBox_stateTag_sale" v-if="statusData.productData.product_sale === 1">Sale</div>
            <div class="mall_pListBox_stateTag_expected" v-if="statusData.productData.product_expected === 1">입고예정</div>
            <div class="mall_pListBox_stateTag_soldOut" v-if="statusData.productData.product_sold_out === 1">Sold out</div>
            <div class="mall_pListBox_stateTag_event" v-if="statusData.productData.product_event === 1">Event</div>
          </div>

          <div class="pageProductDatail_explainBox_brandBox">
            <router-link :to="{name: 'BrandDetail', query: {brand_ID: statusData.productData.brand_ID_product}}">
              {{statusData.productData.brand_eng_name}}
            </router-link>
          </div>

          <p class="pageProductDatail_explainBox_productName">
            {{statusData.productData.product_kor_name}}
          </p>

          <p class="pageProductDatail_explainBox_productInfo" v-if="statusData && statusData.productData">
            <template v-if="statusData.productData.product_phone_inquiry_status === 1">
              센텀점 문의
            </template>
            <template v-else-if="statusData.productData.product_discount === 0">
              KRW {{ formatPrice(statusData.productData.product_sale_price) }}
            </template>
            <template v-else>
              <div>
                <p class="dc_origin">KRW {{ formatPrice(statusData.productData.product_sale_price) }}</p>
                <p class="dc_dcPrice">
                  KRW
                  {{formatPrice(statusData.productData.product_discount)}}
                </p>
              </div>
            </template>

          </p>
          <!-- 제품 옵션 : 기타 옵션 -->
          <template v-if="statusData.productData.product_phone_inquiry_status === 0 || statusData.productData.product_phone_inquiry_status === 1">
            <template v-if="statusData.productData.product_option_status === 0">
              <!-- 기존 옵션 선택 부분 -->
              <div
                class="pageProductDatail_explainBox_sub"
                v-for="item in statusData.productOptionData"
                :key="item.product_option_ID"
              >
                <label :for="'product_option_' + item.product_option_ID">
                  {{item.product_option_name}}
                </label>
                <select
                  :id="'product_option_' + item.product_option_ID"
                  @change="add_product_option_list($event, item.product_option_ID)"
                >
                  <option
                    :value="'0'"
                    :product_option_list_plus_sale_price="'0'"
                  >
                    [필수] 옵션을 선택하세요.
                  </option>
                  <option
                    v-for="product_option_list_item in item.product_option_list"
                    :key="product_option_list_item.product_option_list_ID"
                    :value="product_option_list_item.product_option_list_ID"
                    :product_option_list_plus_sale_price="product_option_list_item.product_option_list_plus_sale_price"
                  >
                    {{
                      product_option_list_item.product_option_list_name +
                      (product_option_list_item.product_option_list_plus_sale_price !== 0 ?
                        // eslint-disable-next-line vue/no-parsing-error
                        '&nbsp&nbsp&nbsp + KRW ' + String(product_option_list_item.product_option_list_plus_sale_price).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '')
                    }}
                  </option>
                </select>
              </div>
            </template>

            <!-- 추가된 그룹 옵션 선택 부분 -->
            <template v-else-if="statusData.productData.product_option_status === 1">
              <div class="pageProductDatail_explainBox_sub">
                <label for="group_option_select">{{statusData.productData.product_group_option_title}}</label>
                <select id="group_option_select" @change="selectGroupOption">
                  <option
                    v-for="groupOption in statusData.groupOptions"
                    :key="groupOption.product_group_option_ID"
                    :value="groupOption.product_group_option_ID"
                  >
                    {{ groupOption.product_group_option_name }}
                  </option>
                </select>
              </div>
              <div
                class="pageProductDatail_explainBox_sub"
                v-if="statusData.selectedGroupOption && statusData.selectedGroupOption.product_option"
                v-for="item in statusData.selectedGroupOption.product_option"
                :key="item.product_option_ID"
              >
                <label :for="'product_option_' + item.product_option_ID">
                  {{item.product_option_name}}
                </label>
                <select
                  :id="'product_option_' + item.product_option_ID"
                  @change="add_product_option_list($event, item.product_option_ID)"
                >
                  <option
                    :value="'0'"
                    :product_option_list_plus_sale_price="'0'"
                  >
                    [필수] 옵션을 선택하세요.
                  </option>
                  <option
                    v-for="product_option_list_item in item.product_option_list"
                    :key="product_option_list_item.product_option_list_ID"
                    :value="product_option_list_item.product_option_list_ID"
                    :product_option_list_plus_sale_price="product_option_list_item.product_option_list_plus_sale_price"
                  >
                    {{
                      product_option_list_item.product_option_list_name +
                      (product_option_list_item.product_option_list_plus_sale_price !== 0 ?
                        // eslint-disable-next-line vue/no-parsing-error
                        '&nbsp&nbsp&nbsp + KRW ' + String(product_option_list_item.product_option_list_plus_sale_price).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '')
                    }}
                  </option>
                </select>
              </div>
            </template>

            <div class="pageProductDatail_explainBox_sub" v-if="statusData.productData.product_phone_inquiry_status === 0 && statusData.productData.product_note_title">
              <p>{{statusData.productData.product_note_title}}</p>
              <div>
                <textarea v-model="formData.product_note" maxlength="500"/>
              </div>
            </div>

            <div class="pageProductDatail_explainBox_quantity" v-if="statusData.productData.product_phone_inquiry_status === 0">
              <p>수량</p>
              <div>
                <button v-on:click="change_selling_count(-1)"></button>
                <p>{{formData.selling_count}}</p>
                <button v-on:click="change_selling_count(+1)"></button>
              </div>
            </div>

              <!-- 옵션선택 안내 문구 및 총 가격 -->
            <div
              class="pageProductDatail_explainBox_infoTxt"
              v-if="statusData.sellingStatus === 0 && statusData.productData.product_phone_inquiry_status === 0"
            >
              <p>옵션을 선택하면 상품금액이 나타납니다.</p>
            </div>

            <div
              class="pageProductDatail_explainBox_priceTxt"
              v-if="statusData.sellingStatus === 1 && statusData.productData.product_phone_inquiry_status === 0">
              <p>총 상품금액</p>
              <p v-if="statusData.productData.product_discount === 0">
                {{ String(Math.floor(formData.sellingPrice * formData.selling_count)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}<span>원</span>
              </p>
              <p v-else>
                <span class="pageProductDatail_explainBox_dcPrice">{{ String(Math.floor(formData.sellingPrice * formData.selling_count)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}원</span>
                <span>{{ String(Math.floor(formData.sellingDiscountPrice * formData.selling_count)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}<span>원</span></span>
              </p>
            </div>

            <!-- 구매 버튼 -->
            <div class="pageProductDatail_buyBtn" v-if="statusData.sellingStatus === 1 && statusData.productData.product_phone_inquiry_status === 0">
              <button v-on:click="add_cart">Add to Cart</button>
              <button v-on:click="buy">Buy Now</button>
            </div>
          </template>
        </div> <!-- 제품 설명박스 -->

        <div class="pageProductDatail_imgDetail pageProductDatail_imgDetailMob"> <!-- 상세이미지 Mob용 -->
          <!-- 동영상1 임시로 주석처리함
          <video
            :src="statusData.productData.product_video+'#t=0.1'"
            controls
            playsinline
            v-if="statusData.productData.product_video"
            /> -->
          <img
            :src="statusData.productData.product_image_detail"
            :alt="statusData.productData.product_eng_name"
          />
          <video
            :src="statusData.productData.product_video_2+'#t=0.1'"
            controls
            playsinline
            v-if="statusData.productData.product_video_2"
            />
          <img
            :src="statusData.productData.product_image_detail_2"
            :alt="statusData.productData.product_eng_name"
          />
        </div>
      </div>
    </div>

    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import { ref } from 'vue'
import {
  get_product_one,
  get_product_group_option,
  get_product_option,
  get_product_option_list,
  get_session_customer,
  check_user_cart_list,
  insert_cart_list,
  update_cart_list
} from '../../ETC/Axios.vue'

export default {
  name: 'ProductDetail',
  components: {
    Header: Header,
    Footer: Footer,
    Scroll: Scroll
  },
  setup () {
    const currentImage = ref('')
    return {
      formData: ref({
        product_ID_use_selling: 0,
        sellingPrice: 0,
        sellingDiscountPrice: 0,
        productOptionListSelectArray: [],
        selling_count: 1,
        product_note: ''
      }),
      statusData: ref({
        productData: {},
        groupOptions: [],
        productOptionData: [],
        selectedGroupOption: {},
        sellingStatus: 0
      }),
      sessionData: ref({
        customer: ''
      }),
      currentImage
    }
  },
  methods: {
    formatPrice (price) {
      return String(Math.floor(price)).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    updateCharacterCount (event) {
      const textLength = event.target.value.length
      document.getElementById('character_count').textContent = `${textLength}/100`
    },
    hoverImage (isHovering) {
      if (isHovering) {
        this.currentImage = this.statusData.productData.product_image_hover
      } else {
        this.currentImage = this.statusData.productData.product_image
      }
    },
    change_selling_count: function (change_count_number) {
      if (this.formData.selling_count + change_count_number <= 0) {
        alert('1개 이상부터 구매할 수 있는 상품입니다.')
      } else {
        this.formData.selling_count = this.formData.selling_count + change_count_number
      }
    },
    add_cart: function () {
      if (this.statusData.sellingStatus === 0) {
        alert('옵션을 선택해주세요.')
        return
      }
      const cartItem = {
        product_ID_use_selling: this.formData.product_ID_use_selling,
        sellingPrice: this.formData.sellingPrice,
        sellingDiscountPrice: this.formData.sellingDiscountPrice,
        productOptionListSelectArray: this.formData.productOptionListSelectArray,
        selling_count: this.formData.selling_count,
        product_note_title: this.statusData.productData.product_note_title,
        product_note: this.formData.product_note,
        product_group_option_title: this.statusData.selectedGroupOption ? this.statusData.productData.product_group_option_title : '',
        product_group_option_name: this.statusData.selectedGroupOption ? this.statusData.selectedGroupOption.product_group_option_name : ''
      }
      if (this.sessionData.customer === '') {
        const cartList = JSON.parse(localStorage.getItem('cart_list')) || []
        cartList.push(cartItem)
        localStorage.setItem('cart_list', JSON.stringify(cartList))
      } else {
        check_user_cart_list(this.sessionData.customer.customer_ID).then(existingCartList => {
          const cartList = existingCartList.length === 0 ? [] : JSON.parse(existingCartList[0].cart_list_array)
          cartList.push(cartItem)
          const updateFunction = existingCartList.length === 0 ? insert_cart_list : update_cart_list
          updateFunction(this.sessionData.customer.customer_ID, JSON.stringify(cartList))
        })
      }
      if (confirm('장바구니에 담겼습니다. 장바구니로 이동하시겠습니까?')) {
        window.location.href = '/CartList'
      }
    },
    buy () {
      if (this.statusData.sellingStatus === 0 && this.statusData.sellingDiscountPrice === 0) {
        alert('옵션을 선택해주세요.')
        return
      }
      const route = this.sessionData.customer === '' ? '/Login?buy_status=1' : '/Order'
      const buyItem = {
        product_ID_use_selling: this.formData.product_ID_use_selling,
        sellingPrice: this.formData.sellingPrice,
        sellingDiscountPrice: this.formData.sellingDiscountPrice,
        productOptionListSelectArray: this.formData.productOptionListSelectArray,
        selling_count: this.formData.selling_count,
        product_note_title: this.statusData.productData.product_note_title,
        product_note: this.formData.product_note,
        product_group_option_title: this.statusData.selectedGroupOption ? this.statusData.productData.product_group_option_title : '',
        product_group_option_name: this.statusData.selectedGroupOption ? this.statusData.selectedGroupOption.product_group_option_name : ''
      }
      const buyArray = [buyItem]
      localStorage.setItem('buy_list', JSON.stringify(buyArray))
      this.$router.push({ path: route })
    },
    filteredGroupOptionsByGroupOption (groupOptionID) {
      return this.statusData.scheduleOptionRows.filter(
        option => option.schedule_group_option_ID_use_schedule_option === groupOptionID
      )
    },
    selectGroupOption (event) {
      const selectedGroupOptionID = event.target.value
      if (selectedGroupOptionID !== '0') {
        const selectedGroupOption = this.statusData.groupOptions.find(option => +option.product_group_option_ID === +selectedGroupOptionID)
        if (selectedGroupOption) {
          this.statusData.selectedGroupOption = selectedGroupOption
          this.formData.productOptionListSelectArray = selectedGroupOption.product_option.map(option => ({
            product_option_ID: option.product_option_ID,
            product_option_list_ID: '0',
            product_option_list_plus_sale_price: '0'
          }))
          this.formData.sellingPrice = this.statusData.productData.product_sale_price
          this.formData.sellingDiscountPrice = this.statusData.productData.product_discount
          this.updateSellingStatus()
          this.$forceUpdate()
        }
      } else {
        this.statusData.selectedGroupOption = null
        this.formData.productOptionListSelectArray = []
        this.formData.sellingPrice = this.statusData.productData.product_sale_price
        this.formData.sellingDiscountPrice = this.statusData.productData.product_discount
        this.$forceUpdate()
      }
    },
    add_product_option_list (event, optionID) {
      const idx = event.target.selectedIndex
      const option = event.target.querySelectorAll('option')[idx]
      const selectedOption = this.formData.productOptionListSelectArray.find(opt => +opt.product_option_ID === +optionID)
      if (selectedOption) {
        selectedOption.product_option_list_ID = event.target.value
        selectedOption.product_option_list_plus_sale_price = parseInt(option.getAttribute('product_option_list_plus_sale_price'), 10)
        this.updateSellingStatus()
        this.$forceUpdate()
      }
    },
    updateSellingStatus () {
      let allOptionsSelected = true
      this.formData.sellingPrice = this.statusData.productData.product_sale_price
      this.formData.sellingDiscountPrice = this.statusData.productData.product_discount

      this.formData.productOptionListSelectArray.forEach(element => {
        if (element.product_option_list_ID === '0') {
          allOptionsSelected = false
        } else {
          const option = this.statusData.productData.product_option_status === 0
            ? this.statusData.productOptionData.find(opt => +opt.product_option_ID === +element.product_option_ID)
            : this.statusData.selectedGroupOption.product_option.find(opt => +opt.product_option_ID === +element.product_option_ID)
          const selectedOption = option.product_option_list.find(opt => +opt.product_option_list_ID === +element.product_option_list_ID)
          if (selectedOption) {
            if (this.statusData.productData.product_discount !== 0) {
              this.formData.sellingDiscountPrice += parseInt(
                selectedOption.product_option_list_plus_sale_price,
                10
              )
            }
            this.formData.sellingPrice += parseInt(
              selectedOption.product_option_list_plus_sale_price,
              10
            )
          }
        }
      })
      this.statusData.sellingStatus = allOptionsSelected ? 1 : 0
    }
  },
  mounted () {
    get_product_one(this.$route.query.product_ID).then(result_product => {
      this.formData.product_ID_use_selling = +this.$route.query.product_ID
      this.statusData.productData = result_product[0]
      this.formData.sellingPrice = result_product[0].product_sale_price
      this.formData.sellingDiscountPrice = result_product[0].product_discount
      this.currentImage = result_product[0].product_image

      if (result_product[0].product_option_status === 0) {
        get_product_option(this.$route.query.product_ID, 0).then(result_product_option => {
          this.statusData.productOptionData = result_product_option
          if (this.statusData.productOptionData.length === 0) {
            this.statusData.sellingStatus = 1
          } else {
            this.statusData.productOptionData.forEach(element => {
              element.product_option_list = []
              this.formData.productOptionListSelectArray.push({
                product_option_ID: element.product_option_ID,
                product_option_list_ID: '0',
                product_option_list_plus_sale_price: '0'
              })
              get_product_option_list(this.$route.query.product_ID, 0).then(result_product_option_list => {
                result_product_option_list.forEach(element_option_list => {
                  if (element.product_option_ID === element_option_list.product_option_ID_use_product_option_list) {
                    element.product_option_list.push(element_option_list)
                  }
                })
                this.$forceUpdate()
              })
            })
          }
        })
      } else {
        get_product_group_option(this.$route.query.product_ID).then(result_product_group_option => {
          this.statusData.groupOptions = result_product_group_option

          const promises = result_product_group_option.map(async groupOption => {
            return get_product_option(this.$route.query.product_ID, groupOption.product_group_option_ID).then(result_product_option => {
              groupOption.product_option = result_product_option
              const listPromises = result_product_option.map(option => {
                return get_product_option_list(this.$route.query.product_ID, groupOption.product_group_option_ID).then(result_product_option_list => {
                  option.product_option_list = []
                  result_product_option_list.forEach(element_option_list => {
                    if (option.product_option_ID === element_option_list.product_option_ID_use_product_option_list) {
                      option.product_option_list.push(element_option_list)
                    }
                  })
                })
              })
              return Promise.all(listPromises)
            })
          })
          Promise.all(promises).then(() => {
            if (this.statusData.groupOptions.length > 0) {
              this.statusData.selectedGroupOption = this.statusData.groupOptions[0]
              this.formData.productOptionListSelectArray = this.statusData.selectedGroupOption.product_option.map(option => ({
                product_option_ID: option.product_option_ID,
                product_option_list_ID: '0',
                product_option_list_plus_sale_price: '0'
              }))
              this.formData.sellingPrice = this.statusData.productData.product_sale_price
              this.formData.sellingDiscountPrice = this.statusData.productData.product_discount
              this.updateSellingStatus()
              this.$nextTick(() => {
                document.getElementById('group_option_select').value = this.statusData.groupOptions[0].product_group_option_ID
                this.$forceUpdate()
              })
            }
          })
        })
      }
    })
    get_session_customer().then(result => {
      this.sessionData.customer = result
    })
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Product/ProductDetail.vue